module.exports = __webpack_public_path__ + "img/131.10aa9781.jpg";